import {Component, OnDestroy, OnInit} from '@angular/core';
import {Store} from '@ngrx/store';
import * as fromApp from '../../../store/app.reducers';
import {ActivatedRoute, Params} from '@angular/router';
import {ProfileService} from '../../profile.service';
import {Observable, Subscription} from 'rxjs';
import * as fromProfile from '../../store/profile.reducers';
import * as ProfileActions from '../../store/profile.actions';

@Component({
    selector: 'app-tiktok-profile-audit',
    templateUrl: './profile-audit.component.html',
    styleUrls: ['./profile-audit.component.scss'],
    standalone: false
})
export class ProfileAuditComponent implements OnInit, OnDestroy {

  profileState: Observable<fromProfile.State>;
  routeSubscription: Subscription;
  profileSubscription: Subscription;
  id: number;
  code: string;
  trialPercent: number;
  trialTimeout: any;

  constructor(
    private store: Store<fromApp.AppState>,
    private route: ActivatedRoute,
    private profileService: ProfileService
  ) { }

  ngOnInit() {
    this.trialPercent = 10;
    this.store.dispatch(
      new ProfileActions.ClearCharts()
    );
    this.profileState = this.store.select('profile');
    this.routeSubscription = this.route.params.subscribe(
      (params: Params) => {
        if (params.id !== undefined) {
          this.id = params.id;
        }
        this.code = params.code;
        if (this.id !== undefined) {
          this.store.dispatch(
            new ProfileActions.GetProfileDetail({id: this.id, params: {code: this.code}})
          );
          // this.store.dispatch(
          //   new ProfileActions.GetProfileProgress({id: this.id, params: {code: this.code}})
          // );
          this.store.dispatch(
            new ProfileActions.GetAudit({id: this.id, params: {code: this.code}})
          );

          this.store.dispatch(
            new ProfileActions.GetProfileAudienceTiktok({id: this.id, params: {code: this.code}})
          );

          this.store.dispatch(
            new ProfileActions.GetFollowerEngage({
              id: +this.id,
              type: 4,
              params: {code: this.code}
            })
          );

          this.store.dispatch(
            new ProfileActions.GetMediaAnalyze({
              id: +this.id,
              type: 1,
              params: {
                code: this.code
              }
            })
          );

        }
      }
    );

    // if (
    //   state.profileProgress !== null &&
    //   state.profileProgress.media.percent < 100
    // ) {
    //   if (this.trialTimeout !== undefined) {
    //     clearTimeout(this.trialTimeout);
    //   }
    //   this.trialTimeout = setTimeout(() => {
    //     if (state.profileProgress !== null && state.profileProgress.media.percent === 100) {
    //       this.trialPercent = 100;
    //     } else {
    //       this.trialPercent = Math.min(this.trialPercent + this.getRandomInt(1, 4), 94);
    //     }
    //   }, 6000);
    //
    // } else if (state.profileProgress !== null && state.profileProgress.media.percent === 100) {
    //   this.trialPercent = 100;
    // }
  }

  ngOnDestroy() {
    if (this.profileSubscription !== undefined) {
      this.profileSubscription.unsubscribe();
    }
    this.routeSubscription.unsubscribe();
  }

}
